export const navigationPtBr = {
  common: {
    comingSoon: 'Em breve',
    preview: 'Preview',
    pendingReviewCount_one: '{{count}} aguardando revisão',
    pendingReviewCount_other: '{{count}} aguardando revisão',
    unreadReviewIndicator: 'Há Revisão não lida',
    searchPlaceholder: 'Buscar...',
    toggleSidebar: 'Alternar barra lateral',
    sidebarTitle: 'Barra lateral',
    sidebarDescription: 'Exibe a barra lateral móvel.',
    sidebarDisplayOptions: 'Exibição da barra lateral',
    openNavItem: 'Abrir {{name}}',
    closeFlyout: 'Fechar menu {{name}}',
    logoAlt: 'Alchemy',
    collapseSidebarTitle: 'Recolher sidebar',
    collapseSidebarThisPage: 'Recolher nesta página',
    collapseSidebarThisPageDesc: 'Volta ao normal quando navegar',
    collapseSidebarPin: 'Fixar recolhido',
    collapseSidebarPinDesc: 'Mantém em todas as páginas',
    expandSidebarTitle: 'Expandir barra lateral',
    expandSidebarThisPageDesc: 'Volta a recolher quando navegar',
    expandSidebarPin: 'Fixar expandido',
    expandSidebarPinDesc: 'Mantém em todas as páginas',
    expandSidebarThisPage: 'Expandir nesta página',
  },
  spotlight: {
    placeholder: 'Ir para...',
    empty: 'Nenhuma página encontrada.',
    hint: 'Use ↑↓ para navegar, Enter para selecionar',
    recent: 'Recentes',
    quickActions: 'Ações rápidas',
    morePages: 'Mais páginas',
    sidebarHint: 'Ou Ctrl/Cmd + K para buscar',
  },
  groups: {
    lab: {
      label: 'Laboratório',
      cockpit: 'Cockpit',
      inbox: 'Inbox',
      alquimia: 'AlquimIA',
      managerDashboard: 'Painel do gestor',
    },
    cash: {
      label: 'Caixa',
      dashboard: 'Dashboard',
      reconciliation: 'Conciliação bancária',
      reconciliationQueue: 'Conciliação bancária v2',
      bankAccounts: 'Contas bancárias',
      creditCards: 'Cartões de crédito',
      cardFastTrack: 'Classificação rápida',
      investments: 'Investimentos',
      loans: 'Empréstimos',
    },
    receivables: {
      label: 'Entradas',
      invoices: 'Contas a receber',
      preBilling: 'Pré-faturamento',
      emittedNfs: 'Notas emitidas',
      debitNotes: 'Notas de débito',
      arForecast: 'Previsão de recebimentos',
      services: 'Serviços',
      costServices: 'Serviços de custo',
      costProvisions: 'Custos provisionados',
      contractTemplates: 'Templates de contratos',
      contracts: 'Contratos',
      customers: 'Clientes',
      billingGroups: 'Grupos de cobrança',
      revenueCycles: 'Ciclos de receita',
      advanced: 'Avançado',
      saasMetrics: 'Métricas SaaS',
    },
    payables: {
      label: 'Saídas',
      vendors: 'Fornecedores',
      bills: 'Contas a pagar',
      recurringDashboard: 'Recorrências',
      advanced: 'Avançado',
      payments: 'Pagamentos',
      ddaInbox: 'Boletos recebidos (DDA)',
      paymentsNeedsReview: 'Pagamentos em revisão',
      receivedNfs: 'Notas recebidas',
    },
    procurement: {
      label: 'Compras',
      requests: 'Requisições de compra',
      orders: 'Pedidos de compra',
      approvalWorkflows: 'Fluxos de aprovação',
      settings: 'Configurações',
    },
    contractReview: {
      label: 'Revisão de contratos',
      reviews: 'Revisões',
      settings: 'Configurações',
    },
    people: {
      label: 'Pessoas',
      employees: 'Colaboradores',
      payroll: 'Folha de pagamento',
      payrollGlMapping: 'Contabilização da folha',
    },
    closing: {
      label: 'Fechamento',
      checklist: 'Checklist',
      customTasks: 'Tarefas customizadas',
      multicurrency: 'Multimoeda',
      multicurrencyClosing: 'Fechamento Multimoeda',
    },
    reports: {
      label: 'Contabilidade',
      operations: 'Operação',
      reporting: 'Relatórios',
      assets: {
        title: 'Ativos',
        reviewQueue: 'Fila de revisão',
        registry: 'Ativos imobilizados',
        leases: 'Arrendamentos',
        onboarding: 'Configurar módulo',
        intangibles: 'Intangíveis',
        rules: 'Regras',
      },
      accountingDeferrals: 'Diferimentos',
      expenseAccruals: 'Provisões de despesas',
      fiscal: 'Fiscal',
      balanceSheet: 'Balanço patrimonial',
      trialBalance: 'Balancete',
      ledger: 'Razão',
      taxAssessments: 'Apurações fiscais',
      fiscalObligations: 'Central de obrigações',
      manualEntries: 'Lançamento manual',
      originLink: 'Vínculos de origem',
    },
    fpa: {
      label: 'FP&A',
      budget: 'Orçamento',
      dre: 'DRE',
      team: 'Equipe',
      cashFlow: 'Fluxo de caixa',
      parameterizations: 'Parametrizações',
      rollups: 'Rollups',
      forecastRuleSets: 'Conjuntos de regras',
      modelagem: 'Modelagem',
    },
    settings: {
      label: 'Configurações',
      allSettings: 'Todas as configurações',
      mcp: 'MCP',
      accounting: {
        title: 'Contábil & Fiscal',
        accountMapping: 'Mapeamento de contas',
        books: 'Livros',
        entities: 'Entidades',
        calendars: 'Calendários',
        periods: 'Períodos',
        fiscalAutomation: 'Automação fiscal',
      },
      fiscal: {
        title: 'Fiscal',
        regimeAliquotas: 'Regime e alíquotas',
        accountMapping: 'Mapeamentos',
      },
      chartOfAccounts: {
        title: 'Plano de contas',
        accounting: 'Plano de contas',
        managerial: 'Gerencial',
        systemAccounts: 'Contas do sistema',
      },
      automations: {
        title: 'Automações',
        classificationRules: 'Classificações',
        approvalWorkflows: 'Fluxos de aprovação',
        fiscalAutomation: 'Automação fiscal',
      },
      organization: {
        title: 'Gerencial',
        departments: 'Departamentos',
        costCenters: 'Centros de custos',
        customFields: 'Campos customizados',
        approvalSettings: 'Configurações de aprovação',
        approvals: {
          title: 'Aprovações',
          rules: 'Regras de aprovação',
          flows: 'Fluxos de aprovação',
          procurement: 'Políticas de compras',
        },
        reimbursements: 'Reembolsos',
        reimbursementPolicySettings: 'Configurações das políticas',
        reimbursementCategories: 'Categorias de reembolso',
        reimbursementPublicLinks: 'Links públicos',
        contractReviewSettings: 'Config. revisão de contratos',
        globalSettings: 'Contexto organização',
      },
      preferences: {
        title: 'Preferências',
        themes: 'Temas',
        user: 'Preferências',
      },
      integrations: {
        title: 'Integrações',
        manage: 'Gerenciamento',
        dimensionReconciliation: 'Mapeamentos',
      },
      usersPermissions: {
        title: 'Usuários & permissões',
        users: 'Usuários',
        invitations: 'Convites',
        roles: 'Papéis',
        permissions: 'Permissões',
        changePassword: 'Alterar senha',
        tenants: 'Organizações',
        auditLogs: 'Logs de auditoria',
      },
    },
  },
  defaults: {
    userName: 'Usuário',
    userEmail: 'usuario@alinea.health',
    teamName: 'Alchemy',
    teamPlan: 'MVP',
  },
  userMenu: {
    upgradeToPro: 'Fazer upgrade para Pro',
    account: 'Conta',
    myAccount: 'Minha conta',
    billing: 'Cobrança',
    notifications: 'Notificações',
    themes: 'Temas',
    darkMode: 'Modo escuro',
    lightMode: 'Modo claro',
    logOut: 'Sair',
  },
};

export const navigationEn = {
  common: {
    comingSoon: 'Coming Soon',
    preview: 'Preview',
    pendingReviewCount_one: '{{count}} pending review',
    pendingReviewCount_other: '{{count}} pending review',
    unreadReviewIndicator: 'There is unread Revisão',
    searchPlaceholder: 'Search...',
    toggleSidebar: 'Toggle Sidebar',
    sidebarTitle: 'Sidebar',
    sidebarDescription: 'Displays the mobile sidebar.',
    sidebarDisplayOptions: 'Sidebar display',
    openNavItem: 'Open {{name}}',
    closeFlyout: 'Close {{name}} menu',
    logoAlt: 'Alchemy',
    collapseSidebarTitle: 'Collapse sidebar',
    collapseSidebarThisPage: 'Collapse on this page',
    collapseSidebarThisPageDesc: 'Returns to normal when you navigate',
    collapseSidebarPin: 'Keep collapsed',
    collapseSidebarPinDesc: 'Stays collapsed on all pages',
    expandSidebarTitle: 'Expand sidebar',
    expandSidebarThisPageDesc: 'Collapses again when you navigate',
    expandSidebarPin: 'Pin expanded',
    expandSidebarPinDesc: 'Stays expanded on all pages',
    expandSidebarThisPage: 'Expand on this page',
  },
  spotlight: {
    placeholder: 'Go to...',
    empty: 'No pages found.',
    hint: 'Use ↑↓ to navigate, Enter to select',
    recent: 'Recent',
    quickActions: 'Quick Actions',
    morePages: 'More Pages',
    sidebarHint: 'Shortcut: Ctrl + K',
  },
  groups: {
    lab: {
      label: 'Laboratory',
      cockpit: 'Cockpit',
      inbox: 'Inbox',
      alquimia: 'AlchimIA',
      managerDashboard: 'Manager dashboard',
    },
    cash: {
      label: 'Cash',
      dashboard: 'Dashboard',
      reconciliation: 'Bank reconciliation',
      reconciliationQueue: 'Bank reconciliation v2',
      bankAccounts: 'Bank accounts',
      creditCards: 'Credit cards',
      cardFastTrack: 'Fast-track classification',
      investments: 'Investments',
      loans: 'Loans',
    },
    receivables: {
      label: 'Inflows',
      preBilling: 'Pre-Billing',
      invoices: 'Invoicing',
      emittedNfs: 'Issued documents',
      debitNotes: 'Debit notes',
      arForecast: 'AR forecast',
      services: 'Services',
      costServices: 'Cost services',
      costProvisions: 'Provisioned costs',
      contractTemplates: 'Contract templates',
      contracts: 'Contracts',
      customers: 'Customers',
      billingGroups: 'Billing groups',
      revenueCycles: 'Revenue cycles',
      advanced: 'Advanced',
      saasMetrics: 'SaaS metrics',
    },
    payables: {
      label: 'Outflows',
      vendors: 'Vendors',
      bills: 'Accounts payable',
      recurringDashboard: 'Recurring',
      advanced: 'Advanced',
      payments: 'Payments',
      ddaInbox: 'Received boletos (DDA)',
      paymentsNeedsReview: 'Payments under review',
      receivedNfs: 'Received documents',
    },
    procurement: {
      label: 'Procurement',
      requests: 'Requests',
      orders: 'Orders',
      approvalWorkflows: 'Approval workflows',
      settings: 'Settings',
    },
    contractReview: {
      label: 'Contract review',
      reviews: 'Reviews',
      settings: 'Settings',
    },
    people: {
      label: 'People',
      employees: 'Employees',
      payroll: 'Payroll',
      payrollGlMapping: 'Payroll accounting',
    },
    closing: {
      label: 'Closing',
      checklist: 'Checklist',
      customTasks: 'Custom tasks',
      multicurrency: 'Multicurrency',
      multicurrencyClosing: 'Multicurrency Closing',
    },
    reports: {
      label: 'Accounting',
      operations: 'Operations',
      reporting: 'Reports',
      assets: {
        title: 'Assets',
        reviewQueue: 'Review queue',
        registry: 'Fixed assets',
        leases: 'Leases',
        onboarding: 'Set up module',
        intangibles: 'Intangible assets',
        rules: 'Rules',
      },
      accountingDeferrals: 'Accounting deferrals',
      expenseAccruals: 'Expense accruals',
      fiscal: 'Tax',
      balanceSheet: 'Balance Sheet',
      trialBalance: 'Trial Balance',
      ledger: 'General Ledger',
      taxAssessments: 'Tax assessments',
      fiscalObligations: 'Obligations central',
      manualEntries: 'Manual entries',
      originLink: 'Origin links',
    },
    fpa: {
      label: 'FP&A',
      budget: 'Budget',
      dre: 'DRE',
      team: 'Team',
      cashFlow: 'Cash Flow',
      parameterizations: 'Parameterizations',
      rollups: 'Rollups',
      forecastRuleSets: 'Forecast rule sets',
      modelagem: 'Modeling',
    },
    settings: {
      label: 'Settings',
      allSettings: 'All settings',
      mcp: 'MCP',
      accounting: {
        title: 'Accounting & Fiscal',
        accountMapping: 'Account mapping',
        books: 'Accounting books',
        entities: 'Entities',
        calendars: 'Accounting calendars',
        periods: 'Accounting periods',
        fiscalAutomation: 'Fiscal automation',
      },
      fiscal: {
        title: 'Fiscal',
        regimeAliquotas: 'Regime & Rates',
        accountMapping: 'Account Mapping',
      },
      chartOfAccounts: {
        title: 'Chart of accounts',
        accounting: 'Accounting',
        managerial: 'Managerial',
        systemAccounts: 'System accounts',
      },
      automations: {
        title: 'Automations & Approvals',
        classificationRules: 'Classifications',
        approvalWorkflows: 'Approval workflows',
        fiscalAutomation: 'Fiscal automation',
      },
      organization: {
        title: 'Managerial',
        departments: 'Departments',
        costCenters: 'Cost centers',
        customFields: 'Custom fields',
        approvalSettings: 'Approval settings',
        approvals: {
          title: 'Approvals',
          rules: 'Approval rules',
          flows: 'Approval workflows',
          procurement: 'Procurement policies',
        },
        reimbursements: 'Reimbursements',
        reimbursementPolicySettings: 'Policy settings',
        reimbursementCategories: 'Reimbursement categories',
        reimbursementPublicLinks: 'Public links',
        contractReviewSettings: 'Contract review settings',
        globalSettings: 'Global settings',
      },
      preferences: {
        title: 'Preferences',
        themes: 'Themes',
        user: 'My preferences',
      },
      integrations: {
        title: 'Integrations',
        manage: 'Manage integrations',
        dimensionReconciliation: 'Integration mapping',
      },
      usersPermissions: {
        title: 'Users & Permissions',
        users: 'Users',
        invitations: 'Invitations',
        roles: 'Roles',
        permissions: 'Permissions',
        changePassword: 'Change password',
        tenants: 'Tenants',
        auditLogs: 'Audit logs',
      },
    },
  },
  defaults: {
    userName: 'User',
    userEmail: 'user@alchemy.io',
    teamName: 'Alchemy',
    teamPlan: 'MVP',
  },
  userMenu: {
    upgradeToPro: 'Upgrade to Pro',
    account: 'Account',
    myAccount: 'My account',
    billing: 'Billing',
    notifications: 'Notifications',
    themes: 'Themes',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    logOut: 'Log out',
  },
};
